export const apiSendOtp = '/api/identity/sendOtp'
export const apiForgotPassword = '/api/identity/forgotPassword'
